module.exports = __webpack_public_path__ + "img/590.c42a9a69.jpg";